import { Box, Divider, Stack, Typography } from '@mui/material';
import type { RecruitmentPool } from '../../types';
import { CANDIDATE_CHECK_OPTIONS } from '../../constants';
import { CommaListField } from 'framework/ui/field';

const RecruitmentPoolDetailsCard = ({ recruitmentPool }: { recruitmentPool: RecruitmentPool }) => (
  <Stack gap={2} p={2}>
    <Box>
      <Typography variant="subtitle2" color="primary">
        Recruitment team
      </Typography>
      <Divider sx={{ my: 0.5 }} />
      <Typography variant="body2">{recruitmentPool.recruitingTeam.join(', ') || 'Not assigned'}</Typography>
    </Box>
    <Box>
      <Typography variant="subtitle2" color="primary">
        Description
      </Typography>
      <Divider sx={{ my: 0.5 }} />
      <Typography variant="body2">{recruitmentPool.description || 'Not provided'}</Typography>
    </Box>
    <Box>
      <Typography variant="subtitle2" color="primary">
        Required checks
      </Typography>
      <Divider sx={{ my: 0.5 }} />

      <CommaListField
        value={recruitmentPool.requiredCandidateCheckTypes}
        mapValue={val => CANDIDATE_CHECK_OPTIONS.find(option => option.value === val)?.label || val}
      />
    </Box>

    {
      // TODO Add Hiring summary
    }
  </Stack>
);

export default RecruitmentPoolDetailsCard;
